<template>
  <div class="grid-document-header" ref="docHeader">
    <div class="document-logo">
      <div class="document-author-logo">
        <img v-if="clientLogoPath" :src="clientLogoPath" :alt="client.name" />
      </div>
    </div>
  </div>
</template>

<script>
import { getClientLogoPath } from '@/helpers/clientLogo';

export default {
  name: 'PrintHeaderClientSlim',
  props: {
    project: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    client() {
      if (!this.project || !this.project.client) {
        return {};
      }
      return this.project.client;
    },
    clientLogoPath() {
      return getClientLogoPath(this.client);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-document-header {
  margin: 0.6cm 1cm;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 1em;
}
.document-logo {
  text-align: left;
}
.document-author-logo {
  width: 200px;
  min-height: 60px;
}
.document-logo img {
  width: 200px;
  display: block;
}
</style>
